export default {"src":"/_next/static/media/ec-2-instances.76c6cdbd.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};